import React from 'react'
import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'

interface IPanelWrapper extends MarginProps {
  width?: number
  height?: number
}

interface IPanel extends IPanelWrapper {
  title: string
  actionContent?: React.ComponentType | React.ElementType | React.ReactNode
  children?: any
}

const PanelWrapper = styled.div<IPanelWrapper>`
  ${margin}
  ${(props) => props.height && `height: ${props.height}px;`}
  border-radius: 4px;
  border: 1px solid ${(p) => p.theme.colors.gray4};
`

const PanelHeaderBlock = styled.div`
  align-items: center;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray4};
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
`

const PanelBodyBlock = styled.div`
  padding: 14px;
`

const PanelActionBlock = styled.div`
  float: right;
`

const PanelTitle = styled.label`
  ${(p) => p.theme.font({ color: 'gray5', weight: 'medium' })}
  line-height: 24px;
`

const Panel: React.FC<IPanel> = ({ actionContent, children, title, ...props }) => (
  <PanelWrapper {...props}>
    <PanelHeaderBlock>
      <PanelTitle>{title}</PanelTitle>
      {actionContent && <PanelActionBlock>{actionContent}</PanelActionBlock>}
    </PanelHeaderBlock>
    <PanelBodyBlock>{children}</PanelBodyBlock>
  </PanelWrapper>
)

export default Panel
